import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enhanced service worker registration for offline-first PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      
      // Set up update handling
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker installed, show update notification
              showUpdateNotification(() => {
                // Send message to new SW to skip waiting
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              });
            }
          });
        }
      });

      // Handle service worker controller change (when new SW takes over)
      // Commented out to prevent refresh loops during development
      /*
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });
      */

      // Initial data preload after SW is ready (disabled temporarily)
      // This might be causing loading issues, so we'll handle preload in the app
      /*
      if (registration.active) {
        registration.active.postMessage({ type: 'PRELOAD_DATA' });
      }
      */

      // Set up periodic cache cleanup (every 30 minutes)
      setInterval(() => {
        if (registration.active) {
          registration.active.postMessage({ type: 'CLEANUP_CACHE' });
        }
      }, 30 * 60 * 1000);

    } catch (error) {
      console.error('❌ SW registration failed:', error);
    }
  });

  // Enhanced service worker message handling
  navigator.serviceWorker.addEventListener('message', (event) => {
    const { type, data } = event.data || {};
    
    switch (type) {
      case 'sync-success':
        showToast('Changes synced successfully', 'success');
        break;
      case 'data-refreshed':
        break;
      case 'cache-cleaned':
        break;
      default:
    }
  });

  // Handle online/offline status
  window.addEventListener('online', () => {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'ONLINE' });
    }
    showToast('Back online! Syncing changes...', 'info');
  });

  window.addEventListener('offline', () => {
    showToast('You\'re now offline. Changes will sync when reconnected.', 'warning');
  });
}

// Show update notification
function showUpdateNotification(onUpdate) {
  const notification = document.createElement('div');
  notification.innerHTML = `
    <div style="position: fixed; top: 20px; right: 20px; background: #22c55e; color: white; padding: 15px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); z-index: 10000; max-width: 300px;">
      <div style="font-weight: bold; margin-bottom: 8px;">Update Available!</div>
      <div style="margin-bottom: 12px;">A new version of Agricverse is ready.</div>
      <div style="display: flex; gap: 8px;">
        <button onclick="updateApp()" style="background: white; color: #22c55e; border: none; padding: 6px 12px; border-radius: 4px; font-weight: bold; cursor: pointer;">Update</button>
        <button onclick="dismissUpdate()" style="background: transparent; color: white; border: 1px solid white; padding: 6px 12px; border-radius: 4px; cursor: pointer;">Later</button>
      </div>
    </div>
  `;
  
  document.body.appendChild(notification);
  
  window.updateApp = () => {
    onUpdate();
    document.body.removeChild(notification);
  };
  
  window.dismissUpdate = () => {
    document.body.removeChild(notification);
  };
}

// Show toast notifications
function showToast(message, type = 'info') {
  const colors = {
    success: '#22c55e',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6'
  };
  
  const toast = document.createElement('div');
  toast.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: ${colors[type]};
    color: white;
    padding: 12px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 10000;
    animation: slideIn 0.3s ease-out;
    max-width: 300px;
  `;
  
  toast.textContent = message;
  document.body.appendChild(toast);
  
  setTimeout(() => {
    toast.style.animation = 'slideOut 0.3s ease-in forwards';
    setTimeout(() => document.body.removeChild(toast), 300);
  }, 4000);
}

// Add animations
const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
  @keyframes slideOut {
    from { transform: translateX(0); opacity: 1; }
    to { transform: translateX(100%); opacity: 0; }
  }
`;
document.head.appendChild(style);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
